
import { IParamsReportSalaryStaff } from 'features/report/services/types/review';
import { useMemo } from 'react';
import shopSelectors from 'services/shop/selectors';
import { ETemplateReportSallary } from 'services/shop/types/setting';
import useDefaultPayrollTemplate from './defaultPayrollTemplate';
import useReceiptCashRoundUpDownTemplate from './cashRoundUpDownTemplate';

const usePayrollTemplate = (params: IParamsReportSalaryStaff) => {
  const allSetting = shopSelectors.data.allSetting();
  const defaultTemplate = useDefaultPayrollTemplate(params);
  const cashRoundUpDownTemplate = useReceiptCashRoundUpDownTemplate(params);

  const template = useMemo(() => {
    if (allSetting?.templateReportSalary === ETemplateReportSallary.RECEIPT_CASH_ROUND_UP_DOWN) {
      return cashRoundUpDownTemplate;
    }
    return defaultTemplate;
  }, [defaultTemplate]);

  return template;
};

export default usePayrollTemplate;